import {BaseAnimation} from './BaseAnimation';

export class WidthAnimation extends BaseAnimation {

    private fromValue:string|number|null=null;
    private toValue:string|number|null=null;

    public getClass():string {
        return 'width-animation';
    }

    public from(value:string|number) {
        this.fromValue=value;
        if (value=='auto') value=this.element.width()??0;
        this.fromItem.css('width',value);
        return this;
    }

    protected isValidProperty(prop:string) {
        return prop=='width';
    }

    public before() {
        if (this.fromValue===undefined) this.from('auto');
        if (this.toValue===undefined) this.to('auto');
    }

    public after() {
        super.after();
        if (this.toValue=='auto') this.element.css('width','');
    }

    public to(value:string|number) {
        this.toValue=value;
        if (value=='auto' || value=='max') {
            var oldwidth=this.element.css('width');
            this.element.css('width','');
            var maxwidth;
            if (value=='max') {
                let winw=$(window).width()??0;
                maxwidth=winw-this.element[0].getBoundingClientRect().left;
            } else {
                maxwidth=Number.MAX_VALUE;
            }
            value=this.element.width()??0;
            value=Math.min(value,maxwidth);

            this.element.css('width',oldwidth);
        }
        this.toItem.css('width',value);
        return this;
    }

}

export {};